import { render, staticRenderFns } from "./custom-form-select.vue?vue&type=template&id=5d4bd220&scoped=true&"
import script from "./custom-form-select.vue?vue&type=script&lang=js&"
export * from "./custom-form-select.vue?vue&type=script&lang=js&"
import style0 from "./custom-form-select.vue?vue&type=style&index=0&id=5d4bd220&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4bd220",
  null
  
)

component.options.__file = "custom-form-select.vue"
export default component.exports